import { Interceptor } from "@connectrpc/connect";

export const headerInterceptor: Interceptor = (next) => (req) => {
  const authToken = req.header.get("Authorization");
  if (authToken) {
    const authMetadata = getAuthMetadata(authToken);
    if (authMetadata?.cid) {
      req.header.set("x-checkout-correlation-id", authMetadata.cid);
    }
    if (authMetadata?.mid) {
      req.header.set("x-checkout-merchant-id", authMetadata.mid);
    }
    if (authMetadata?.rid) {
      req.header.set("requestId", authMetadata.rid);
    }
  }
  return next(req);
};

export const createVersionHeaderInterceptor: (
  version: string
) => Interceptor = (version) => {
  const versionHeaderInterceptor: Interceptor = (next) => (req) => {
    if (version) {
      req.header.set("x-checkout-version", version);
    }

    return next(req);
  };

  return versionHeaderInterceptor;
};

const getAuthMetadata = (token: string): Partial<CheckoutIntentPayload> => {
  const parts = token.split(".");

  if (parts.length !== 3) {
    return {};
  }
  try {
    return JSON.parse(atob(parts[1])) as CheckoutIntentPayload;
  } catch (e) {
    return {};
  }
};

export type CheckoutIntentPayload = {
  ksi: string;
  Role: Array<string>;
  mor: string;
  od: string;
  iss: string;
  mid: string;
  oid: string;
  exp: number;
  msr: string;
  spi: string;
  iat: number;
  cid: string;
  rid: string;
};
